import { ajaxHandler } from './AjaxHandler';
import { API_KEYS } from '../config/apiKeys';

const postQuoteRequest = params => {
    return api(`${API_KEYS.API_URL}/v0/public/quote-request`).postNoToken(params);
};

const api = url => {
    return {
        postNoToken: params => ajaxHandler('POST', url, params),
    };
};

export default postQuoteRequest;
